.nav {
    position: relative;
    top: 0;
    z-index: 100;
}

.sticky {
    position: sticky;
}

.root {
    position: relative;
    height: var(--main-nav-height);
    background-color: transparent;
    transition: background-color 0.2s;
    z-index: 1;
}

.darkNoBackground {
    composes: root;
    composes: darkBase from "../../styles/theming.module.css";
}

.darkBackground {
    composes: root;
    composes: darkBase from "../../styles/theming.module.css";
    background-color: rgb(var(--black-base) / 65%);
    backdrop-filter: blur(15px);
}

.overlapNav {
    composes: root;
    position: absolute;
    width: 100%;
}

.lightOverlapNav {
    composes: overlapNav;
    composes: darkBase from "../../styles/theming.module.css";
}

.darkOverlapNav {
    composes: overlapNav;
    composes: lightBase from "../../styles/theming.module.css";
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    height: 100%;
}

.inner {
    grid-column: 1 / -1;
    height: 100%;
}

.topRow {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
}

.logo {
    display: flex;

    svg {
        width: 175px;
        height: 25px;
        fill: var(--color-text-primary);
    }
}

.burgerTrigger {
    display: flex;

    svg {
        width: 25px;
        height: 25px;
        fill: var(--color-text-primary);
    }
}

.burgerSvg {
    & path {
        transition:
            opacity 0.2s,
            transform 0.2s,
            fill 0.2s;
        transform-origin: center;
    }
}

.burger {
    composes: burgerSvg;
    fill: var(--color-text-primary);

    & :global(.topBar) {
        transform: translateY(0) rotate(0deg) translateZ(0);
    }

    & :global(.middleBar) {
        opacity: 1;
    }

    & :global(.bottomBar) {
        transform: translateY(0) rotate(0deg) translateZ(0);
    }
}

.xIcon {
    composes: burgerSvg;
    fill: var(--black);

    :global(.topBar) {
        transform: translate3d(-24%, 25%, 0) rotate(45deg) scaleX(1.3);
    }

    :global(.middleBar) {
        opacity: 0;
    }

    :global(.bottomBar) {
        transform: translate3d(-24%, -25%, 0) rotate(-45deg) scaleX(1.3);
    }
}
